import { LED, usePipecatConnectionState } from "@pipecat-ai/voice-ui-kit";
import { useTranslation } from "react-i18next";
import { MicIcon } from "./MicIcon";

export function Header() {
    const { t } = useTranslation();
    const { isConnected, isConnecting } = usePipecatConnectionState();
    const statusLabel = isConnected
        ? t("header.status.connected")
        : isConnecting
          ? t("header.status.connecting")
          : t("header.status.disconnected");

    return (
        <header className="shrink-0 border-b border-zinc-200 bg-white">
            <div className="flex h-12 w-full items-center justify-between px-4">
                <div className="flex items-center gap-2.5">
                    <div className="flex size-8 items-center justify-center rounded-md bg-zinc-200 text-zinc-500">
                        <MicIcon />
                    </div>
                    <span className="text-[15px] font-semibold text-zinc-800">
                        {t("header.title")}
                    </span>
                </div>

                <div className="flex items-center gap-1.5">
                    <LED
                        on={isConnected || isConnecting}
                        blinking={isConnecting}
                        blinkIntervalMs={400}
                        classNames={{
                            on: "bg-emerald-500",
                            off: "bg-zinc-300",
                        }}
                        className="size-1.5 rounded-full"
                    />
                    <span className="text-[11px] font-medium text-zinc-400">
                        {statusLabel}
                    </span>
                </div>
            </div>
        </header>
    );
}
